import { RegisterType } from "../../../common/interfaces/enums/RegisterType";
import { PublicRoutesConfig } from "../../RoutesConfig";

export function getRoutePath(registerType: RegisterType) {
  if (registerType === RegisterType.TZCertifications) {
    return PublicRoutesConfig.TZCertifications;
  } else {
    return PublicRoutesConfig.ZOZCertifications;
  }
}
